export enum StayType {
  OVERNIGHT = 'overnight',
  DAY_USE = 'dayuse'
}

export enum StayTypeKey {
  OVERNIGHT = 'overnight',
  DAY_USE = 'dayuse'
}
